import React, { PropsWithChildren, useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import breakpoints from "../assets/styles/variables/breakpoints.module.scss";

enum Breakpoints {
  FULLHD = "fhd",
  EXTRALARGE3 = "xxxl",
  EXTRALARGE2 = "xxl",
  EXTRALARGE = "xl",
  LARGE = "lg",
  MEDIUM = "md",
  SMALL = "sm",
  EXTRASMALL = "xs",
}

export type AppResponsiveContextType = {
  isFullHD: boolean;
  isExtraLarge3: boolean;
  isExtraLarge2: boolean;
  isExtraLarge: boolean;
  isLarge: boolean;
  isMedium: boolean;
  isSmall: boolean;
  isExtraSmall: boolean;
};

const initialState: AppResponsiveContextType = {
  isFullHD: false,
  isExtraLarge3: false,
  isExtraLarge2: false,
  isExtraLarge: false,
  isLarge: false,
  isMedium: false,
  isSmall: false,
  isExtraSmall: false,
};

export const AppResponsiveContext =
  React.createContext<AppResponsiveContextType>(initialState);

export const AppResponsiveProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const [mounted,setMounted] = useState(false)

  useEffect(()=>{
    setMounted(true)
  },[])
  const isFullHD = useMediaQuery({
    query: `(min-width: ${breakpoints[Breakpoints.EXTRALARGE2]}px)`,
  });
  const isExtraLarge3 = useMediaQuery({
    query: `(min-width: ${breakpoints[Breakpoints.EXTRALARGE2]}px)`,
  });
  const isExtraLarge2 = useMediaQuery({
    query: `(min-width: ${breakpoints[Breakpoints.EXTRALARGE3]}px)`,
  });
  const isExtraLarge = useMediaQuery({
    query: `(min-width: ${breakpoints[Breakpoints.EXTRALARGE]}px)`,
  });
  const isLarge = useMediaQuery({
    query: `(min-width: ${breakpoints[Breakpoints.LARGE]}px)`,
  });
  const isMedium = useMediaQuery({
    query: `(min-width: ${breakpoints[Breakpoints.MEDIUM]}px)`,
  });
  const isSmall = useMediaQuery({
    query: `(min-width: ${breakpoints[Breakpoints.SMALL]}px)`,
  });
  const isExtraSmall = useMediaQuery({
    query: `(min-width: ${breakpoints[Breakpoints.EXTRASMALL]}px)`,
  });

  if(!mounted){
    return <></>
  }
  return (
    <AppResponsiveContext.Provider
      value={{
        isFullHD,
        isExtraLarge3,
        isExtraLarge2,
        isExtraLarge,
        isLarge,
        isMedium,
        isSmall,
        isExtraSmall,
      }}
    >
      {children}
    </AppResponsiveContext.Provider>
  );
};
